import {SignalR} from '../../constants/actionType';

export function setFloHubConnectionState(value) {
  return {type: SignalR.SET_FLO_HUB_CONNECTION_STATE, value};
}

export function setDeviceHubConnectionState(value) {
  return {type: SignalR.SET_DEVICE_HUB_CONNECTION_STATE, value};
}

export const sessionIsTakenOver = (sessionIsTakenOver) => ({
  type: SignalR.SET_SESSION_TAKEN_OVER,
  sessionIsTakenOver,
});
